import React, { FC } from "react";
import { Typography } from "@material-ui/core";
import { useIntl } from "react-intl";

import { useStyles } from "./FavouritesSettingsHeader.styles";
import { IFavouritesSettingsHeaderProps } from "./FavouritesSettingsHeader.types";
import { messages } from "./FavouritesSettingsHeader.messages";

const formatter = Intl.DateTimeFormat("en-US", {
  month: "long",
  day: "numeric",
  year: "numeric",
});

export const FavouritesSettingsHeader: FC<IFavouritesSettingsHeaderProps> = (props) => {
  const { item } = props;
  const { formatMessage } = useIntl();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="h3">
        {item.name}
      </Typography>
      <Typography className={classes.subtitle}>{`${formatMessage(messages.saveDate)}: ${formatter.format(
        new Date(item.date)
      )}`}</Typography>
    </div>
  );
};
